import React from "react";

import Navbar from "./Navbar";
import Components from "./Components";
import Footer from "./Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Components />
      <Footer />
    </div>
  );
}

export default App;
